<template>
    <div>
        <v-checkbox style="width: auto !important" :color="entityConfig.primaryColor" @click="openIframe()" v-model="checked" :label="checkboxData.label" />
        <v-dialog v-model="visibleIframe" scrollable persistent max-width="1000px">
        <v-card> 
            <iframe title="Terminos" :src="checkboxData.url" width="100%" :height="checkboxData.height" frameborder="0" ></iframe>
            <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn :color="entityConfig.primaryColor" outlined @click="cancel">
                {{ $t("terms.disagree") }}
            </v-btn>
            <v-btn
                :color="entityConfig.primaryColor"
                depressed
                :style="`color: ${entityConfig.secondaryColor}`"
                @click="accept"
            >
                {{ $t("terms.agree") }}
            </v-btn>
            </v-card-actions>
        </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    props:  {
        checkboxData: {
            type: Object,
            default() {
                return { type: 'raw-html' }
            }
        },
    },
    data: () => ({
        checked: false,
        visibleIframe: false,
        entityConfig: {},
    }),
    mounted() {
        this.entityConfig = this.$store.state.entityConfig.config;
    },
    methods: {
        accept() {
            this.visibleIframe = false;
            this.$emit("accepted");
        },
        cancel() {
            this.checked = false;
            this.visibleIframe = false;
            this.$emit("canceled");
        },
        openIframe() {
        if (this.checked) {
            this.visibleIframe = true;
        } else {
            this.$emit("canceled");
        }
        },
  },
}
</script>